

function initSearchForm() {
    $('.form-search-event').on('submit', function (ev) {
        if (window.ga) {
            if (typeof empty_search === 'undefined' || empty_search === null) {
                ga('send', 'event', {
                    eventCategory: 'Search',
                    eventAction: $(this).data('search-type'),
                    eventLabel: $(this).find('.input-search-event').val(),
                    transport: 'beacon'
                });
            } else {
                ga('send', 'event', {
                    eventCategory: 'Search',
                    eventAction: 'Empty',
                    eventLabel: $(this).find('.input-search-event').val(),
                    transport: 'beacon'
                });
            }
        }
    });
}

/* Close top warning */

$(document).ready(function () {
    $(".close").click(function () {
        $(".alert-dismissible").fadeOut("normal", function () {
            $(this).remove();
        });
    });
});

/**
 * FloatLabels
 * URL: http://clubdesign.github.io/floatlabels.js/
 * Author: Marcus Pohorely ( http://www.clubdesign.at )
 * Copyright: Copyright 2013 / 2014 http://www.clubdesign.at
 *
 * Adapted for bootstrap projects by Michael Levin 2/20/14
 */

(function (e, t, n, r) {
    function o(t, n) {
        this.$element = e(t);
        this.settings = e.extend({}, s, n);
        this.init()
    } var i = "floatlabel",
        s = { slideInput: true, labelStartTop: "0px", labelEndTop: "0px", paddingOffset: "3px", transitionDuration: .1, transitionEasing: "ease-in-out", labelClass: "", typeMatches: /text|password|email|number|search|url/ };
    o.prototype = {
        init: function () {
            var e = this,
                n = this.settings,
                r = n.transitionDuration,
                i = n.transitionEasing,
                s = this.$element; var o = { "-webkit-transition": "all " + r + "s " + i, "-moz-transition": "all " + r + "s " + i, "-o-transition": "all " + r + "s " + i, "-ms-transition": "all " + r + "s " + i, transition: "all " + r + "s " + i }; if (s.prop("tagName").toUpperCase() !== "INPUT" && s.prop("tagName").toUpperCase() !== "TEXTAREA" && s.prop("tagName").toUpperCase() !== "SELECT") { return } if (s.prop("tagName").toUpperCase() == "INPUT" && !n.typeMatches.test(s.attr("type"))) { return } var u = s.attr("id"); if (!u) {
                    u = Math.floor(Math.random() * 100) + 1;
                    s.attr("id", u)
                } var a = s.attr("placeholder"); var f = s.data("label"); var l = s.data("class"); if (!l) { l = "" } if (!a || a === "") { a = "You forgot to add placeholder attribute!" } if (!f || f === "") { f = a } this.inputPaddingTop = parseFloat(s.css("padding-top")) + parseFloat(n.paddingOffset);
            s.wrap('<div class="floatlabel-wrapper" style="position:relative"></div>');
            s.before('<label for="' + u + '" class="label-floatlabel ' + n.labelClass + " " + l + '">' + f + "</label>");
            this.$label = s.prev("label"); if (s.prop("tagName").toUpperCase() == "SELECT") { this.$label.css({ position: "absolute", top: n.labelStartTop, left: "8px", "font-size": "11px", "font-weight": "bold", color: "#838780", "background-color": "white", "padding-left": "5px", "padding-right": "5px", display: "block", "-moz-opacity": "1", "-khtml-opacity": "1", "-webkit-opacity": "1", opacity: "1" }) } else { this.$label.css({ position: "absolute", top: n.labelStartTop, left: "8px", "font-size": "11px", "font-weight": "bold", color: "#838780", "background-color": "white", "padding-left": "5px", "padding-right": "5px", display: "none", "-moz-opacity": "0", "-khtml-opacity": "0", "-webkit-opacity": "0", opacity: "0" }) } if (!n.slideInput) { s.css({ "padding-top": this.inputPaddingTop }) } s.on("keyup blur change", function (t) { e.checkValue(t) });
            s.on("blur", function () { s.prev("label").css({ color: "#838780" }) });
            s.on("focus", function () { s.prev("label").css({ color: "#2996cc" }) });
            t.setTimeout(function () {
                e.$label.css(o);
                e.$element.css(o)
            }, 100);
            this.checkValue()
        }, checkValue: function (e) {
            if (e) { var t = e.keyCode || e.which; if (t === 9) { return } } var n = this.$element,
                r = n.data("flout"); if (n.val() !== "") { n.data("flout", "1") } if (n.val() === "") { n.data("flout", "0") } if (n.data("flout") === "1" && r !== "1") { this.showLabel() } if (n.prop("tagName").toUpperCase() !== "SELECT") { if (n.data("flout") === "0" && r !== "0") { this.hideLabel() } }
        }, showLabel: function () {
            var e = this;
            e.$label.css({ display: "block" });
            t.setTimeout(function () { e.$label.css({ top: e.settings.labelStartTop, "-moz-opacity": "1", "-khtml-opacity": "1", "-webkit-opacity": "1", opacity: "1" }); if (e.settings.slideInput) { e.$element.css({ "padding-top": e.inputPaddingTop }) } e.$element.addClass("active-floatlabel") }, 50)
        }, hideLabel: function () {
            var e = this;
            e.$label.css({ top: e.settings.labelStartTop, "-moz-opacity": "0", "-khtml-opacity": "0", "-webkit-opacity": "0", opacity: "0" }); if (e.settings.slideInput) { e.$element.css({ "padding-top": parseFloat(e.inputPaddingTop) - parseFloat(this.settings.paddingOffset) }) } e.$element.removeClass("active-floatlabel");
            t.setTimeout(function () { e.$label.css({ display: "none" }) }, e.settings.transitionDuration * 1e3)
        }
    };
    e.fn[i] = function (t) { return this.each(function () { if (!e.data(this, "plugin_" + i)) { e.data(this, "plugin_" + i, new o(this, t)) } }) }
})(jQuery, window, document)

$(document).ready(function () {

    $('.floatlabel').floatlabel({
        slideInput: false
    });

});

/**
 * Fontello
 * URL: https://github.com/fontello
 */

function toggleCodes(on) {
    var obj = document.getElementById('icons');

    if (on) {
        obj.className += ' codesOn';
    } else {
        obj.className = obj.className.replace(' codesOn', '');
    }
}

/*
 * bootstrap-tagsinput v0.8.0
 * master:resources/assets/js/vendor/global/global.js
 */

! function (a) {
    "use strict";

    function b(b, c) { this.isInit = !0, this.itemsArray = [], this.$element = a(b), this.$element.hide(), this.isSelect = "SELECT" === b.tagName, this.multiple = this.isSelect && b.hasAttribute("multiple"), this.objectItems = c && c.itemValue, this.placeholderText = b.hasAttribute("placeholder") ? this.$element.attr("placeholder") : "", this.inputSize = Math.max(1, this.placeholderText.length), this.$container = a('<div class="bootstrap-tagsinput"></div>'), this.$input = a('<input type="text" placeholder="' + this.placeholderText + '"/>').appendTo(this.$container), this.$element.before(this.$container), this.build(c), this.isInit = !1 }

    function c(a, b) {
        if ("function" != typeof a[b]) {
            var c = a[b];
            a[b] = function (a) { return a[c] }
        }
    }

    function d(a, b) {
        if ("function" != typeof a[b]) {
            var c = a[b];
            a[b] = function () { return c }
        }
    }

    function e(a) { return a ? i.text(a).html() : "" }

    function f(a) {
        var b = 0; if (document.selection) {
            a.focus(); var c = document.selection.createRange();
            c.moveStart("character", -a.value.length), b = c.text.length
        } else (a.selectionStart || "0" == a.selectionStart) && (b = a.selectionStart); return b
    }

    function g(b, c) {
        var d = !1; return a.each(c, function (a, c) {
            if ("number" == typeof c && b.which === c) return d = !0, !1; if (b.which === c.which) {
                var e = !c.hasOwnProperty("altKey") || b.altKey === c.altKey,
                    f = !c.hasOwnProperty("shiftKey") || b.shiftKey === c.shiftKey,
                    g = !c.hasOwnProperty("ctrlKey") || b.ctrlKey === c.ctrlKey; if (e && f && g) return d = !0, !1
            }
        }), d
    } var h = { tagClass: function (a) { return "label label-info" }, focusClass: "focus", itemValue: function (a) { return a ? a.toString() : a }, itemText: function (a) { return this.itemValue(a) }, itemTitle: function (a) { return null }, freeInput: !0, addOnBlur: !0, maxTags: void 0, maxChars: void 0, confirmKeys: [13, 44], delimiter: ",", delimiterRegex: null, cancelConfirmKeysOnEmpty: !1, onTagExists: function (a, b) { b.hide().fadeIn() }, trimValue: !1, allowDuplicates: !1, triggerChange: !0 };
    b.prototype = {
        constructor: b, add: function (b, c, d) {
            var f = this; if (!(f.options.maxTags && f.itemsArray.length >= f.options.maxTags) && (b === !1 || b)) {
                if ("string" == typeof b && f.options.trimValue && (b = a.trim(b)), "object" == typeof b && !f.objectItems) throw "Can't add objects when itemValue option is not set"; if (!b.toString().match(/^\s*$/)) {
                    if (f.isSelect && !f.multiple && f.itemsArray.length > 0 && f.remove(f.itemsArray[0]), "string" == typeof b && "INPUT" === this.$element[0].tagName) {
                        var g = f.options.delimiterRegex ? f.options.delimiterRegex : f.options.delimiter,
                            h = b.split(g); if (h.length > 1) { for (var i = 0; i < h.length; i++) this.add(h[i], !0); return void (c || f.pushVal(f.options.triggerChange)) }
                    } var j = f.options.itemValue(b),
                        k = f.options.itemText(b),
                        l = f.options.tagClass(b),
                        m = f.options.itemTitle(b),
                        n = a.grep(f.itemsArray, function (a) { return f.options.itemValue(a) === j })[0]; if (!n || f.options.allowDuplicates) {
                            if (!(f.items().toString().length + b.length + 1 > f.options.maxInputLength)) {
                                var o = a.Event("beforeItemAdd", { item: b, cancel: !1, options: d }); if (f.$element.trigger(o), !o.cancel) {
                                    f.itemsArray.push(b); var p = a('<span class="tag ' + e(l) + (null !== m ? '" title="' + m : "") + '">' + e(k) + '<span data-role="remove"></span></span>');
                                    p.data("item", b), f.findInputWrapper().before(p), p.after(" "); var q = a('option[value="' + encodeURIComponent(j) + '"]', f.$element).length || a('option[value="' + e(j) + '"]', f.$element).length; if (f.isSelect && !q) {
                                        var r = a("<option selected>" + e(k) + "</option>");
                                        r.data("item", b), r.attr("value", j), f.$element.append(r)
                                    } c || f.pushVal(f.options.triggerChange), (f.options.maxTags === f.itemsArray.length || f.items().toString().length === f.options.maxInputLength) && f.$container.addClass("bootstrap-tagsinput-max"), a(".typeahead, .twitter-typeahead", f.$container).length && f.$input.typeahead("val", ""), this.isInit ? f.$element.trigger(a.Event("itemAddedOnInit", { item: b, options: d })) : f.$element.trigger(a.Event("itemAdded", { item: b, options: d }))
                                }
                            }
                        } else if (f.options.onTagExists) {
                            var s = a(".tag", f.$container).filter(function () { return a(this).data("item") === n });
                            f.options.onTagExists(b, s)
                        }
                }
            }
        }, remove: function (b, c, d) {
            var e = this; if (e.objectItems && (b = "object" == typeof b ? a.grep(e.itemsArray, function (a) { return e.options.itemValue(a) == e.options.itemValue(b) }) : a.grep(e.itemsArray, function (a) { return e.options.itemValue(a) == b }), b = b[b.length - 1]), b) {
                var f = a.Event("beforeItemRemove", { item: b, cancel: !1, options: d }); if (e.$element.trigger(f), f.cancel) return;
                a(".tag", e.$container).filter(function () { return a(this).data("item") === b }).remove(), a("option", e.$element).filter(function () { return a(this).data("item") === b }).remove(), -1 !== a.inArray(b, e.itemsArray) && e.itemsArray.splice(a.inArray(b, e.itemsArray), 1)
            } c || e.pushVal(e.options.triggerChange), e.options.maxTags > e.itemsArray.length && e.$container.removeClass("bootstrap-tagsinput-max"), e.$element.trigger(a.Event("itemRemoved", { item: b, options: d }))
        }, removeAll: function () {
            var b = this; for (a(".tag", b.$container).remove(), a("option", b.$element).remove(); b.itemsArray.length > 0;) b.itemsArray.pop();
            b.pushVal(b.options.triggerChange)
        }, refresh: function () {
            var b = this;
            a(".tag", b.$container).each(function () {
                var c = a(this),
                    d = c.data("item"),
                    f = b.options.itemValue(d),
                    g = b.options.itemText(d),
                    h = b.options.tagClass(d); if (c.attr("class", null), c.addClass("tag " + e(h)), c.contents().filter(function () { return 3 == this.nodeType })[0].nodeValue = e(g), b.isSelect) {
                        var i = a("option", b.$element).filter(function () { return a(this).data("item") === d });
                        i.attr("value", f)
                    }
            })
        }, items: function () { return this.itemsArray }, pushVal: function () {
            var b = this,
                c = a.map(b.items(), function (a) { return b.options.itemValue(a).toString() });
            b.$element.val(c, !0), b.options.triggerChange && b.$element.trigger("change")
        }, build: function (b) {
            var e = this; if (e.options = a.extend({}, h, b), e.objectItems && (e.options.freeInput = !1), c(e.options, "itemValue"), c(e.options, "itemText"), d(e.options, "tagClass"), e.options.typeahead) {
                var i = e.options.typeahead || {};
                d(i, "source"), e.$input.typeahead(a.extend({}, i, {
                    source: function (b, c) {
                        function d(a) {
                            for (var b = [], d = 0; d < a.length; d++) {
                                var g = e.options.itemText(a[d]);
                                f[g] = a[d], b.push(g)
                            } c(b)
                        } this.map = {}; var f = this.map,
                            g = i.source(b);
                        a.isFunction(g.success) ? g.success(d) : a.isFunction(g.then) ? g.then(d) : a.when(g).then(d)
                    }, updater: function (a) { return e.add(this.map[a]), this.map[a] }, matcher: function (a) { return -1 !== a.toLowerCase().indexOf(this.query.trim().toLowerCase()) }, sorter: function (a) { return a.sort() }, highlighter: function (a) { var b = new RegExp("(" + this.query + ")", "gi"); return a.replace(b, "<strong>$1</strong>") }
                }))
            } if (e.options.typeaheadjs) {
                var j = null,
                    k = {},
                    l = e.options.typeaheadjs;
                a.isArray(l) ? (j = l[0], k = l[1]) : k = l, e.$input.typeahead(j, k).on("typeahead:selected", a.proxy(function (a, b) { k.valueKey ? e.add(b[k.valueKey]) : e.add(b), e.$input.typeahead("val", "") }, e))
            } e.$container.on("click", a.proxy(function (a) { e.$element.attr("disabled") || e.$input.removeAttr("disabled"), e.$input.focus() }, e)), e.options.addOnBlur && e.options.freeInput && e.$input.on("focusout", a.proxy(function (b) { 0 === a(".typeahead, .twitter-typeahead", e.$container).length && (e.add(e.$input.val()), e.$input.val("")) }, e)), e.$container.on({ focusin: function () { e.$container.addClass(e.options.focusClass) }, focusout: function () { e.$container.removeClass(e.options.focusClass) } }), e.$container.on("keydown", "input", a.proxy(function (b) {
                var c = a(b.target),
                    d = e.findInputWrapper(); if (e.$element.attr("disabled")) return void e.$input.attr("disabled", "disabled"); switch (b.which) {
                        case 8:
                            if (0 === f(c[0])) {
                                var g = d.prev();
                                g.length && e.remove(g.data("item"))
                            } break;
                        case 46:
                            if (0 === f(c[0])) {
                                var h = d.next();
                                h.length && e.remove(h.data("item"))
                            } break;
                        case 37:
                            var i = d.prev();
                            0 === c.val().length && i[0] && (i.before(d), c.focus()); break;
                        case 39:
                            var j = d.next();
                            0 === c.val().length && j[0] && (j.after(d), c.focus())
                    } var k = c.val().length;
                Math.ceil(k / 5);
                c.attr("size", Math.max(this.inputSize, c.val().length))
            }, e)), e.$container.on("keypress", "input", a.proxy(function (b) {
                var c = a(b.target); if (e.$element.attr("disabled")) return void e.$input.attr("disabled", "disabled"); var d = c.val(),
                    f = e.options.maxChars && d.length >= e.options.maxChars;
                e.options.freeInput && (g(b, e.options.confirmKeys) || f) && (0 !== d.length && (e.add(f ? d.substr(0, e.options.maxChars) : d), c.val("")), e.options.cancelConfirmKeysOnEmpty === !1 && b.preventDefault()); var h = c.val().length;
                Math.ceil(h / 5);
                c.attr("size", Math.max(this.inputSize, c.val().length))
            }, e)), e.$container.on("click", "[data-role=remove]", a.proxy(function (b) { e.$element.attr("disabled") || e.remove(a(b.target).closest(".tag").data("item")) }, e)), e.options.itemValue === h.itemValue && ("INPUT" === e.$element[0].tagName ? e.add(e.$element.val()) : a("option", e.$element).each(function () { e.add(a(this).attr("value"), !0) }))
        }, destroy: function () {
            var a = this;
            a.$container.off("keypress", "input"), a.$container.off("click", "[role=remove]"), a.$container.remove(), a.$element.removeData("tagsinput"), a.$element.show()
        }, focus: function () { this.$input.focus() }, input: function () { return this.$input }, findInputWrapper: function () { for (var b = this.$input[0], c = this.$container[0]; b && b.parentNode !== c;) b = b.parentNode; return a(b) }
    }, a.fn.tagsinput = function (c, d, e) {
        var f = []; return this.each(function () {
            var g = a(this).data("tagsinput"); if (g)
                if (c || d) {
                    if (void 0 !== g[c]) {
                        if (3 === g[c].length && void 0 !== e) var h = g[c](d, null, e);
                        else var h = g[c](d);
                        void 0 !== h && f.push(h)
                    }
                } else f.push(g);
            else g = new b(this, c), a(this).data("tagsinput", g), f.push(g), "SELECT" === this.tagName && a("option", a(this)).attr("selected", "selected"), a(this).val(a(this).val())
        }), "string" == typeof c ? f.length > 1 ? f : f[0] : f
    }, a.fn.tagsinput.Constructor = b; var i = a("<div />");
    a(function () { a("input[data-role=tagsinput], select[multiple][data-role=tagsinput]").tagsinput() })
}(window.jQuery);

$(document).ready(function () {
    addReadMoreFunctionality();
});

/* Show less /more
 *
 *
 */

$(document).ready(function () {
    $('.share-overlay').hide();
    $("#sharethis_embed").click(function () {
        $('.share-overlay').show();
        return false;
    });

    $("#closethis_embed").click(function () {
        $(".share-overlay").hide();
        return false;
    });
});

/*
 * Embed endcard toggle share screen
 * @todo Revisar si realmente es necesario que esto esté aquí
 */

/*
 * Copy to clipboard
 */

$(document).ready(function () {

    /* Copiar contenido del input al hacer click en el boton de clipboard. Prevenir que cierre el modal y que envie el form */
    $(".clipboard").click(function () {
        $(this).unbind('click.remodal');
        $(this).addClass("clipboard-copied");
    });

    /* Initialize clipboard.min.js */
    new Clipboard('.clipboard');
});

/* Share embed video overlay tabs */

$(document).ready(function () {
    $('#tabs div').hide();
    $('#tabs div#tab-1').show();

    $('#tabs ul li.toggle-link a').click(function () {
        $('#tabs ul li.toggle-link').addClass('active');
        $('#tabs ul li.toggle-code').removeClass('active');
        $('#tabs div#tab-1').show();
        $('#tabs div#tab-2').hide();
    });

    $('#tabs ul li.toggle-code a').click(function () {
        $('#tabs ul li.toggle-code').addClass('active');
        $('#tabs ul li.toggle-link').removeClass('active');
        $('#tabs div#tab-1').hide();
        $('#tabs div#tab-2').show();
    });
});

/* Icon reactions */

$(document).ready(function () {

    function randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    $('.js-fav-reaction').click(function () {

        $('.video-container').addClass('has-fav');
        $('<svg style="left: ' + randomIntFromInterval(28, 32) + '%" version="1.1" class="animated-reaction animated-fav-reaction" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 269 264" xml:space="preserve"><g id="Circle"> <circle cx="134.7" cy="131.1" r="52"/> </g> <path class="heart-icon st7" d="M131.9,110.7c-6.8-6.3-17.4-6-23.7,0.8c-6.3,6.8-6,17.4,0.8,23.7l14.4,13.5l11.5,10.7l11.5-10.7 l14.4-13.5c6.8-6.3,7.1-16.9,0.8-23.7c-6.3-6.8-16.9-7.1-23.7-0.8l-2.9,2.7"/> </svg>').appendTo('.video-container').delay(2500).queue(function () { $(this).remove(); });
    });

    $('.js-like-reaction').click(function () {
        $('.video-container').addClass('has-like');
        $('<svg style="left: ' + randomIntFromInterval(35.5, 39.5) + '%" version="1.1" class="animated-reaction animated-like-reaction" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 269 264" xml:space="preserve"><g id="Circle"> <circle cx="134.7" cy="131.1" r="52"/> </g> <path class="like-icon st1" d="M48.93 29.14a6.51 6.51 0 0 1-1.35 4.3 6.45 6.45 0 0 1 0 3.67 6.1 6.1 0 0 1-1.69 2.95 7.54 7.54 0 0 1-1.54 5.68q-2 2.38-6.18 2.45h-4a23.31 23.31 0 0 1-4.52-.49q-2.44-.49-3.81-.91T22 45.54a22.93 22.93 0 0 0-5-1.38 2.07 2.07 0 0 1-1.41-.61 1.88 1.88 0 0 1-.6-1.4v-20.1a1.89 1.89 0 0 1 .56-1.36A2.06 2.06 0 0 1 17 20q.75-.06 2.38-1.85t3.17-3.8a46.36 46.36 0 0 1 3.17-3.76 4.81 4.81 0 0 0 1-1.51 10 10 0 0 0 .55-1.52q.14-.58.42-1.9T28 3.8a9.34 9.34 0 0 1 .61-1.63A5.45 5.45 0 0 1 29.7.6a1.93 1.93 0 0 1 1.42-.6 9.37 9.37 0 0 1 2.58.33 6.87 6.87 0 0 1 1.88.82 4.4 4.4 0 0 1 1.26 1.27 7.3 7.3 0 0 1 .75 1.41A7.91 7.91 0 0 1 38 5.39a13.51 13.51 0 0 1 .16 1.41v1.22a9.78 9.78 0 0 1-.3 2.38 12.81 12.81 0 0 1-.6 1.88q-.3.69-.86 1.76-.09.19-.31.56a5.25 5.25 0 0 0-.34.69 7.9 7.9 0 0 0-.25.75h8.69a6.1 6.1 0 0 1 6 6 6.87 6.87 0 0 1-1.73 4.67 7.48 7.48 0 0 1 .47 2.43zm-36.48-8.47a1.93 1.93 0 0 1 .6 1.41v20.08a2 2 0 0 1-2 2H2a1.93 1.93 0 0 1-1.41-.6 1.93 1.93 0 0 1-.59-1.4V22.08a1.93 1.93 0 0 1 .6-1.41 1.93 1.93 0 0 1 1.4-.6h9a1.93 1.93 0 0 1 1.45.6zM8 38.14a1.93 1.93 0 0 0-.6-1.41 2 2 0 0 0-2.84 0A2 2 0 0 0 6 40.15a2 2 0 0 0 1.41-.58A1.91 1.91 0 0 0 8 38.14z" transform="translate(110 105)"/> </svg>').appendTo('.video-container').delay(2500).queue(function () { $(this).remove(); });
    });

    $('.js-dislike-reaction').click(function () {
        $('.video-container').addClass('has-dislike');
        $('<svg style="left: ' + randomIntFromInterval(43, 47) + '%" version="1.1" class="animated-reaction animated-dislike-reaction" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 269 264" xml:space="preserve"><g id="Circle"> <circle cx="134.7" cy="131.1" r="52"/> </g> <path class="dislike-icon st7" d="M1.26,19a6.51,6.51,0,0,1,1.35-4.3,6.45,6.45,0,0,1,0-3.67A6.1,6.1,0,0,1,4.3,8.12,7.54,7.54,0,0,1,5.84,2.45Q7.84.06,12,0h4a23.31,23.31,0,0,1,4.52.49Q23,1,24.39,1.4t3.78,1.24a22.93,22.93,0,0,0,5,1.38,2.07,2.07,0,0,1,1.41.61,1.88,1.88,0,0,1,.6,1.4V26.13a1.89,1.89,0,0,1-.56,1.36,2.06,2.06,0,0,1-1.35.64q-.75.06-2.38,1.85t-3.17,3.8a46.36,46.36,0,0,1-3.17,3.76,4.81,4.81,0,0,0-1,1.51A10,10,0,0,0,23,40.57q-.14.58-.42,1.9t-.39,1.91A9.34,9.34,0,0,1,21.55,46a5.45,5.45,0,0,1-1.07,1.57,1.93,1.93,0,0,1-1.41.6,9.37,9.37,0,0,1-2.59-.33A6.87,6.87,0,0,1,14.6,47a4.4,4.4,0,0,1-1.26-1.27,7.3,7.3,0,0,1-.75-1.41,7.91,7.91,0,0,1-.38-1.57,13.51,13.51,0,0,1-.16-1.41c0-.31,0-.72,0-1.22a9.78,9.78,0,0,1,.3-2.38,12.81,12.81,0,0,1,.6-1.88q.3-.69.86-1.76.09-.19.31-.56a5.25,5.25,0,0,0,.34-.69,7.9,7.9,0,0,0,.25-.75H6a5.79,5.79,0,0,1-4.23-1.79A5.8,5.8,0,0,1,0,26.1a6.87,6.87,0,0,1,1.73-4.67A7.48,7.48,0,0,1,1.26,19Zm36.48,8.47a1.93,1.93,0,0,1-.6-1.41V6a2,2,0,0,1,2-2h9a2,2,0,0,1,2,2V26.1a2,2,0,0,1-2,2h-9A1.93,1.93,0,0,1,37.73,27.51ZM42.16,10a2,2,0,0,0,3.43,1.41,2,2,0,0,0-2.84-2.84A1.91,1.91,0,0,0,42.16,10Z" transform="translate(110 105)"/> </svg>').appendTo('.video-container').delay(2500).queue(function () { $(this).remove(); });
    });
});

// ================================================
// Tabs
// ================================================

$(document).ready(function () {
    if ($(window).width() <= 768) {
        $('.js-tab').on('click', function () {
            var tab_id = $(this).attr('data-target-tab');
            $('.tab__block').removeClass('is-visible');
            $('.tab__item--section').removeClass('tab--selected');

            $('.' + tab_id).addClass('is-visible');

            if (!$(this).hasClass('tab--selected')) {
                $(this).addClass('tab--selected');
            }
        });
    }
});
// ================================================
// Initialize SVG for Everybody
// ================================================

$(document).ready(function () {
    svg4everybody();
});


$(document).ready(function () {
    var closeBanner = $('.banner__close');
    closeBanner.click(function () {
        $(this).parent().addClass("fadeOutUp");
    });
});
// ================================================
// Mobile pagination behavior
// ================================================

$(document).ready(function () {
    var paginationNextBtn = $('.pagination_item--next .btn-pagination');
    var paginationBtnGutter = 6;
    var paginationContainer = $('.pagination');

    function mobilePagination() {

        var nextBtnWidth = paginationNextBtn.outerWidth();
        var paginationRightPadding = nextBtnWidth + paginationBtnGutter;

        if (paginationContainer.prop('scrollWidth') > paginationContainer.width()) {
            paginationContainer.css('padding-right', paginationRightPadding).addClass('pagination--scrollable');
            paginationNextBtn.addClass('btn-pagination--sticky');
        } else {
            paginationContainer.css('padding-right', 0).removeClass('pagination--scrollable');
            paginationNextBtn.removeClass('btn-pagination--sticky');
        }
    }

    mobilePagination();

    $(window).on('resize', function (e) {
        mobilePagination();
    });

    $('#js-copy-link').click(function () {
        copyFunction();
        $(this).addClass("mobile-over");

        setTimeout(function () {
            $('#js-copy-link').removeClass("mobile-over");
        }, 2000);
    });

    $('#js-copy-link').mouseout(function (event) {
        outFunc();
    });
});

function copyFunction() {
    /* Get the text field */
    var copyText = document.getElementById("myInput");
    buttonCopyElement = document.getElementById("js-copy-link");

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/

    /* Copy the text inside the text field */
    document.execCommand("copy");
    buttonCopyElement.setAttribute("data-after", "Copiado al portapapeles");
}

function outFunc() {
    var copyText = document.getElementById("myInput");
    buttonCopyElement.setAttribute("data-after", "Copiar al portapapeles");
}

$(window).on("load", function () {
    $('html').addClass('has-transitions');
});

window.onload = function () {
    function remove_activeserie_preload() {
        $(".is-active").removeClass("is-active--preload");
    }
    setTimeout(remove_activeserie_preload, 2500);
}

/*$(document).ready(function () {
    // ================================================
    // Sticky footer ad
    // ================================================
    // Show sticky banner after a certain amout of scroll (stickyScrollOffset) and close after clicking "X"

    var footerSticky = $('.js-sticky-banner');
    var footerStickyClose = $('.js-close-button');
    var stickyScrollOffset = 150;

    if (footerSticky.length > 0) {

        var cSticky = Cookies.get('csticky');
        if (!cSticky) {
            $(window).on('scroll', scrollSticky);
        } else {
            footerSticky.addClass("is-disabled");
        }

        $(window).on('scroll', scrollSticky);

        // Show/hide sticky on scroll conditions
        function scrollSticky() {
            if (!window.optidigitalToolbox) {
                return;
            }

            var scrollHeight = $(document).height();
            var scrollPosition = $(window).height() + $(window).scrollTop();

            if (($(window).scrollTop() > stickyScrollOffset) && ((scrollHeight - scrollPosition) / scrollHeight !== 0) && ($(window).width() < 960)) {
                // we have scrolled past a certain offset and we are not at the bottom of the page
                footerSticky.addClass("is-active");

                cSticky = Cookies.get('csticky');
                if (!cSticky) {
                    Cookies.set('csticky', 1, {
                        path: '/;',
                        expires: new Date(new Date().getTime() + 5 * 60 * 1000)
                    });
                    optidigitalToolbox.refreshAdSlots("Mobile_Sticky_Bottom");
                }
            } else {
                footerSticky.removeClass("is-active");
            }

            if ((scrollPosition + 115) >= scrollHeight) {
                footerSticky.removeClass("is-active");
            }
        }

        // Hide sticky when clicking "X"
        footerStickyClose.on('click', function (e) {
            footerSticky.addClass("is-disabled");
        });

        //intensive adds
        //video intensive add sticky bottom show
        setTimeout(function () {
            if (!window.optidigitalToolbox) {
                return;
            }
            $('.sticky-banner--video-desktop').addClass('active');
            optidigitalToolbox.refreshAdSlots("Desktop_Sticky_Bottom");
        }, 3000);
        //video intensive add close button
        $('.js-sticky-banner--video-desktop').click(function () {
            $('.sticky-banner--video-desktop').removeClass('active');
        })
    }
});*/



